import type { DashboardWidgetHost } from '../Host';
import { viewerSnapshotWidget } from './viewer-snapshot/index';
import { cctvStreamWidget } from './cctv-stream/index';
import { chartWidget } from './chart/index';
import { recordListWidget } from './record-list/index';
import { imageWidget } from './image/index';

export { viewerSnapshotWidget } from './viewer-snapshot/index';
export { cctvStreamWidget } from './cctv-stream/index';
export { chartWidget } from './chart/index';
export { recordListWidget } from './record-list/index';
export { imageWidget } from './image/index';

export function registerBuiltins(host: DashboardWidgetHost): void {
  host.register(viewerSnapshotWidget);
  host.register(cctvStreamWidget);
  host.register(chartWidget);
  host.register(recordListWidget);
  host.register(imageWidget);
}
